<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Options") }}
        </div>
      </template>

      <div class="mt-5" v-if="!loading">
        <v-tabs v-model="tab" dark left background-color="grey darken-3">
          <v-tab href="#tab-1">{{ $t("Grundeinstellungen") }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-row>
                <v-col>
                  <h3 class="mb-3">{{ $t("app_name") }}:</h3>
                  <v-text-field
                    v-model="options.app_name"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="app_name"
                    :error-messages="errors.collect('app_name')"
                  ></v-text-field>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_name')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  ><hr class="mt-3 mb-3" />
                  <h3>{{ $t("app_intro") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Deutsch:</p>
                  <VueEditor
                    v-model="options.app_intro"
                    :label="$t('app_intro')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="app_intro"
                    :error-messages="errors.collect('app_intro')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_intro')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <p>Italienisch:</p>
                  <VueEditor
                    v-model="options.app_intro_it"
                    :label="$t('app_intro_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="app_intro_it"
                    :error-messages="errors.collect('app_intro_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_intro_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <hr class="mt-3 mb-3" />
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="5">
                  <h3 class="mb-3">{{ $t("app_background") }}:</h3>
                  <v-file-input
                    v-if="options.app_background == null"
                    filled
                    prepend-icon="mdi-camera"
                    v-model="chosenImage"
                    truncate-length="15"
                    show-size
                    v-on:change="onChangeImageUpload()"
                  ></v-file-input>
                  <div v-else>
                    <v-img :src="options.app_background" aspect-ratio="2">
                    </v-img>
                    <v-btn
                      @click="
                        options.app_background = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("image") }} {{ $t("delete") }}</v-btn
                    >
                  </div>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_background')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col lg="5">
                  <h3 class="mb-3">{{ $t("pdf_background") }}:</h3>
                  <v-file-input
                    v-if="options.pdf_background == null"
                    filled
                    prepend-icon="mdi-camera"
                    v-model="chosenPdfBackground"
                    truncate-length="15"
                    show-size
                    v-on:change="onChangePdfBackgroundUpload()"
                  ></v-file-input>
                  <div v-else>
                    <v-img :src="options.pdf_background">
                    </v-img>
                    <v-btn
                      @click="
                        options.pdf_background = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("image") }} {{ $t("delete") }}</v-btn
                    >
                  </div>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('pdf_background')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem, saveItem } from "../shared/services";

export default {
  name: "app-option-list",
  data() {
    return {
      options: {},
      loading: true,
      chosenImage: null,
      chosenFile: null,
      chosenLogo: null,
      chosenFooter: null,
      chosenFooter1: null,
      tab: null,
      customToolbar: [
        [{ header: [false, 1, 2] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ]
    };
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems();

      response.data.forEach(
        element => (this.options[element.key] = element.value)
      );
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Option?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async saveOption(key) {
      let resp = await saveItem(null, { key: key, value: this.options[key] });
      if (resp.success) {
        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
      this.getData();
    },
    onChangeImageUpload() {
      this.fileUpload("background");
    },
    onChangePdfBackgroundUpload() {
      this.fileUpload("pdf_background");
    },
    onChangeLogoUpload() {
      this.fileUpload("logo");
    },
    onChangeFooterUpload() {
      this.fileUpload("footer");
    },
    onChangeFooter1Upload() {
      this.fileUpload("footer1");
    },
    onChangeFileUpload() {
      this.fileUpload("file");
    },
    fileUpload(type) {
      if (this.chosenFile || this.chosenImage || this.chosenLogo || this.chosenFooter || this.chosenFooter1 || this.chosenPdfBackground) {
        let formData = new FormData();
        this.uploaderLoading = true;
        if (type == "background") {
          formData.append("background", this.chosenImage);
        } else if (type == "logo") {
          formData.append("logo", this.chosenLogo);
        } else if (type == "file") {
          formData.append("file", this.chosenFile);
        } else if (type == "footer") {
          formData.append("footer", this.chosenFooter);
        } else if (type == "footer1") {
          formData.append("footer1", this.chosenFooter1);
        } else if (type == "pdf_background") {
          formData.append("pdf_background", this.chosenPdfBackground);
        }
        this.axios
          .post("/api/option/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(data => {
            this.uploaderLoading = false;
            this.chosenLogo = null;
            this.chosenImage = null;
            this.chosenFile = null;
            this.chosenFooter = null;
            this.chosenFooter1 = null;
            this.chosenPdfBackground = null;
            if (type == "background") {
              if (data.data.length) {
                this.options.app_background = data.data;
              }
            } else if (type == "logo") {
              if (data.data.length) {
                this.options.app_logo = data.data;
              }
            } else if (type == "file") {
              if (data.data.length) {
                this.options.app_privacy = data.data;
              }
            } else if (type == "footer") {
              if (data.data.length) {
                this.options.app_footer = data.data;
              }
            } else if (type == "footer1") {
              if (data.data.length) {
                this.options.app_footer_1 = data.data;
              }
            } else if (type == "pdf_background") {
              if (data.data.length) {
                this.options.pdf_background = data.data;
              }
            }

          })
          .catch(error => {
            this.loading = false;
            for (let field in error.response.data.errors) {
              this.$validator.errors.add({
                field: field,
                msg: error.response.data.errors[field][0]
              });
            }
            throw error;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
